/* Florawell product page (fw-pdp) behaviour: gallery, buy box pricing, review filters */

if (!customElements.get('fw-pdp-gallery')) {
  customElements.define(
    'fw-pdp-gallery',
    class FwPdpGallery extends HTMLElement {
      connectedCallback() {
        this.slides = this.querySelectorAll('[data-fw-slide]');
        this.thumbs = this.querySelectorAll('[data-fw-thumb]');
        this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.show(thumb.dataset.fwThumb)));
      }

      show(index) {
        this.slides.forEach((slide) => slide.classList.toggle('is-active', slide.dataset.fwSlide === index));
        this.thumbs.forEach((thumb) => thumb.setAttribute('aria-current', thumb.dataset.fwThumb === index));
      }
    }
  );
}

if (!customElements.get('fw-pdp-buy-box')) {
  customElements.define(
    'fw-pdp-buy-box',
    class FwPdpBuyBox extends HTMLElement {
      connectedCallback() {
        const data = this.querySelector('script[type="application/json"]');
        this.config = data ? JSON.parse(data.textContent) : { variants: [], tiers: [] };
        this.form = this.querySelector('form[action*="/cart/add"]');
        this.variantInput = this.form.querySelector('[name="id"]');
        this.quantityInput = this.form.querySelector('[name="quantity"]');
        this.planInput = this.form.querySelector('[name="selling_plan"]');
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
          style: 'currency',
          currency: this.config.currency || 'GBP',
        });

        this.addEventListener('change', this.update.bind(this));
        this.update();
      }

      get variant() {
        const select = this.querySelector('[data-fw-variant]');
        const id = select ? Number(select.value) : Number(this.variantInput.value);
        return this.config.variants.find((v) => v.id === id) || this.config.variants[0];
      }

      update() {
        const variant = this.variant;
        if (!variant) return;
        this.variantInput.value = variant.id;

        const plan = this.querySelector('[name="fw-plan"]:checked');
        const planId = plan ? plan.value : '';
        const isSub = planId !== '';
        if (this.planInput) {
          this.planInput.value = planId;
          this.planInput.disabled = !isSub;
        }
        const perks = this.querySelector('[data-fw-perks]');
        if (perks) perks.hidden = !isSub;

        const subMult = isSub ? 1 - (variant.subDiscount || 0) / 100 : 1;
        const tierInputs = this.querySelectorAll('[name="fw-tier"]');
        let quantity = 1;
        let tierDiscount = 0;

        tierInputs.forEach((input) => {
          const tier = this.config.tiers[Number(input.value)];
          const per = variant.price * (1 - tier.discount / 100) * subMult;
          const pct = Math.round((1 - per / variant.price) * 100);
          const label = input.closest('.fw-pdp-tier');
          label.querySelector('[data-fw-tier-price]').textContent = this.format(per);
          label.querySelector('[data-fw-tier-save]').textContent = pct > 0 ? `Save ${pct}%` : 'Full price';
          if (input.checked) {
            quantity = tier.quantity;
            tierDiscount = tier.discount;
          }
        });

        this.quantityInput.value = quantity;

        const total = variant.price * (1 - tierDiscount / 100) * subMult * quantity;
        const compare = variant.price * quantity;
        const saving = compare - total;
        const hasSaving = saving > 0.5;

        this.querySelector('[data-fw-total]').textContent = this.format(total);
        const compareEl = this.querySelector('[data-fw-compare]');
        compareEl.textContent = this.format(compare);
        compareEl.hidden = !hasSaving;
        const savingEl = this.querySelector('[data-fw-saving]');
        savingEl.hidden = !hasSaving;
        savingEl.textContent = `You’re saving ${this.format(saving)} (${Math.round((saving / compare) * 100)}%) on this order`;

        const button = this.form.querySelector('[type="submit"]');
        button.disabled = !variant.available;
      }

      format(cents) {
        return this.money.format(cents / 100);
      }
    }
  );
}

if (!customElements.get('fw-pdp-reviews')) {
  customElements.define(
    'fw-pdp-reviews',
    class FwPdpReviews extends HTMLElement {
      connectedCallback() {
        this.reviews = [...this.querySelectorAll('[data-fw-review]')];
        this.chips = this.querySelectorAll('[data-fw-topic]');
        this.moreButton = this.querySelector('[data-fw-more]');
        this.limit = Number(this.dataset.limit) || 6;
        this.topic = '';
        this.expanded = false;

        this.chips.forEach((chip) =>
          chip.addEventListener('click', () => {
            this.topic = chip.dataset.fwTopic;
            this.chips.forEach((c) => c.setAttribute('aria-pressed', c === chip));
            this.render();
          })
        );
        if (this.moreButton) {
          this.moreButton.addEventListener('click', () => {
            this.expanded = true;
            this.render();
          });
        }
        this.render();
      }

      render() {
        const matching = this.reviews.filter((r) => !this.topic || r.dataset.fwReview === this.topic);
        this.reviews.forEach((r) => (r.hidden = true));
        matching.forEach((r, i) => (r.hidden = !this.expanded && i >= this.limit));
        if (this.moreButton) this.moreButton.parentElement.hidden = this.expanded || matching.length <= this.limit;
      }
    }
  );
}
